import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import authService from "../services/authservices";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { Box, Modal } from "@material-ui/core";
import { UserContext } from "../contexts/UserContext";
import { useTranslation } from "react-i18next";
import i18n from "../translate/i18n";

function Forgot() {
  const [verifyStatus, setVerifyStatus] = useState(false);
  const [triedToEnterOtp, setTriedToEnterOtp] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    otp: "",
    password: "",
    confirmPassword: "",
  });
  const { t } = useTranslation();

  const [errors, setErrors] = useState({});
  const [otpSent, setOtpSent] = useState(false);
  const [sentotpsuc, setSentotpsuc] = useState(false);
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");
  const [toastVisible, setToastVisible] = useState(false);
  const [emailValid, setEmailValid] = useState(false);
  const [timer, setTimer] = useState(60); // Start with 60 seconds
  const [emailSubmitted, setEmailSubmitted] = useState(false);
  const [otpLoad, setOtpload] = useState(false);

  const [passHide, setPasshide] = useState(false);
  const [inputType, setinputType] = useState("password");
  const [passHidconf, setPasshideconf] = useState(false);
  const [inputTypeconf, setinputTypeconf] = useState("password");
  const [signloader, setSignloader] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");
  const [error, setError] = useState("");

  const [otpEditable, setOtpEditable] = useState(false);

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);

  const { user } = useContext(UserContext);

  const [verifyLoader, setverifyLoader] = useState(false);
  const [otpsectionopen, setOtpsectionopen] = useState(false);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleCloseOtp = () => setOtpsectionopen(false);

  const navigate = useNavigate();

  const handleInputChangeNew = (e) => {
    const value = e.target.value;
    if (value.length <= 6 && /^[0-9]*$/.test(value)) {
      setVerificationCode(value);
    }
    if (error) {
      setError("");
    }
  };
  const handleKeyDownNew = (e) => {
    // Allow only numbers, Backspace, and Ctrl+V
    const allowedKeys = [
      "Backspace",
      "ArrowLeft",
      "ArrowRight",
      "Delete",
      "Tab",
    ]; // Allow navigation keys and Backspace

    if (
      !/[0-9]/.test(e.key) && // Restrict non-numeric keys
      !allowedKeys.includes(e.key) && // Allow specific keys
      !(e.ctrlKey && e.key === "v") // Allow Ctrl+V for paste
    ) {
      e.preventDefault();
    }
  };
  const handleSubmitNew = async (e) => {
    const value = e.target.value;
    e.preventDefault();
    if (!verificationCode) {
      setError("OTP is required");
      return;
    }
    if (/^\d*$/.test(value)) {
      setVerificationCode(value);
      if (error) {
        setError("");
      }
    }
    try {
      setSignloader(true);
      const response = await authService.verifyOtp({
        email: user.email ? user.email : localStorage.getItem("useremail"),
        emailOtp: Number(verificationCode),
      });
      setSignloader(false);
      if (response.status) {
        showSuccessToast("OTP verified successfully ! Login to continue");
        setOtpsectionopen(false);
        navigate("/login");
      } else {
        showErrorToast(response.Message);
        // setOtpsectionopen(false)
      }
    } catch (error) {
      setSignloader(false);
      // console.error("Error during OTP verification:", error);
      setError("An error occurred. Please try again.");
    }
  };

  const sendOtpresend = async () => {
    try {
      setOtpSent(true);
      setTimer(60); // Start the timer at 60 seconds
      const response = await authService.resendOtp({
        email: user.email ? user.email : localStorage.getItem("useremail"),
      });
      if (response.data.status) {
        setVerificationCode("");
        showSuccessToast("OTP resent successfully!");
      } else {
        setVerificationCode("");
        showErrorToast(
          // response.data.Message || "Failed to resend OTP. Please try again."

          <div className="toast-ml">
            <h4 className="toast-title">Error!</h4>
            <p className="toast-message">
              {response.data.Message ||
                "Failed to resend OTP. Please try again."}
            </p>
          </div>
        );
        setOtpSent(false);
      }
    } catch (error) {
      setVerificationCode("");
      // console.error("Error during OTP resend:", error);
      showErrorToast("An error occurred. Please try again.");
      setOtpSent(false);
    }
  };
  const [otpSent2, setOtpSent2] = useState(false);

  const verify_email = async () => {
    try {
      // var obj = {
      //   email: localStorage.getItem("useremail"),
      // };
      setverifyLoader(true);
      setOtpSent2(true);
      setTimer(60);
      const data = await authService.resendOtp({
        email: localStorage.getItem("useremail"),
      });
      setverifyLoader(false);
      if (data.status) {
        // (data.Message);
        showSuccessToast("OTP sent to your email!");
        sessionStorage.setItem("timerstatus", "true");
        // navigate("/verification");
        setOpen(false);
        setOtpsectionopen(true);
      } else {
        // (data.Message);
        showErrorToast("Please try again later");
      }
    } catch (error) {}
  };

  const sendOtpRequest = async () => {
    try {
      setOtpload(true);
      const response = await authService.forgotPassword({
        email: formData.email,
      });
      localStorage.setItem("useremail", formData.email);
      setOtpload(false);
      if (response.status) {
        // OTP sent successfully
        setOtpSent(true);
        setEmailSubmitted(true);
        setTimer(60); // Reset timer
        showSuccessToast("OTP sent successfully!");
      } else {
        if (response.Message == "Please enter a verified email") {
          handleOpen();
        } else {
          showErrorToast(response.Message);
        }
      }
    } catch (error) {
      showErrorToast("An error occurred while sending OTP. Please try again.");
    }
  };
  const sendOtp = async (value) => {
    if (!emailValid) {
      showErrorToast("Please enter your email");
      return;
    }
    if (value === "Send OTP") {
      await sendOtpRequest();
      setSentotpsuc(true);
    } else if (value === "Resend") {
      await sendOtpRequest();
      setSentotpsuc(false);
    }
    setSentotpsuc(false);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return emailRegex.test(email);
  };
  useEffect(() => {
    if (theme === "dark") {
      document.body.classList.add("dark");
      document.body.classList.remove("light");
    } else {
      document.body.classList.add("light");
      document.body.classList.remove("dark");
    }

    localStorage.setItem("theme", theme);
  }, [theme]);
  useEffect(() => {
    let countdown;
    if (timer > 0 && otpSent) {
      countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      // setOtpSent(false); // Enable "Resend" button after timer ends
      clearInterval(countdown);
    }
    return () => clearInterval(countdown);
  }, [timer, otpSent]);

  useEffect(() => {
    let countdown;
    if (timer > 0 && otpSent2) {
      countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      // setOtpSent(false); // Enable "Resend" button after timer ends
      clearInterval(countdown);
    }
    return () => clearInterval(countdown);
  }, [timer, otpSent2]);

  const showErrorToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true); // Set toast as visible
      toast.error(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset toastVisible on close
          autoClose: 3000, // Optional: auto-close after 3 seconds
        }
      );
    }
  };

  const showSuccessToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true);
      toast.success(
        <div className="toast-ml">
          <h4 className="toast-title">Success!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset state on close
          autoClose: 3000, // Auto-close after 3 seconds
        }
      );
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (name === "email") {
      setTriedToEnterOtp(false);
    }
    let newErrors = { ...errors };
    if (name === "email") {
      setEmailValid(validateEmail(value));
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!value) newErrors.email = "Email is required";
      else if (!emailRegex.test(value))
        newErrors.email = "Invalid email format";
      else delete newErrors.email;
    } else if (name === "otp") {
      if (!value) {
        newErrors.otp = "OTP is required";
      } else if (!/^\d{6}$/.test(value)) {
        newErrors.otp = "OTP must be a 6-digit number";
      } else {
        delete newErrors.otp;
      }
    } else if (name === "password") {
      const passwordRegex =
        /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*?&.]{8,30}$/;
      if (!value) newErrors.password = "Password is required";
      else if (!passwordRegex.test(value))
        newErrors.password =
          "Password must be 8-30 characters long, include uppercase, lowercase, number, and special character";
      else delete newErrors.password;
    } else if (name === "confirmPassword") {
      if (!value) newErrors.confirmPassword = "Confirm Password is required";
      else if (value !== formData.password)
        newErrors.confirmPassword = "Passwords do not match";
      else delete newErrors.confirmPassword;
    }

    setErrors(newErrors);
  };

  const handleKeyDown = (e, type) => {
    // Allow Backspace and Arrow keys for all cases
    if (e.key === "Backspace" || e.key.startsWith("Arrow")) {
      return; // Let these keys be used
    }

    if (type === "email") {
      const regex = /^[a-zA-Z0-9@._-]+$/;
      if (
        !regex.test(e.key) ||
        (e.target.value.length >= 250 && e.key !== "Backspace")
      ) {
        e.preventDefault();
      }
    } else if (type === "password" || type === "confirmPassword") {
      if (
        e.key === " " ||
        (e.target.value.length >= 30 && e.key !== "Backspace")
      ) {
        e.preventDefault();
      }
    } else if (type === "Number") {
      if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
        e.preventDefault();
      }
      if (e.target.value.length >= 6 && e.key !== "Backspace") {
        e.preventDefault(); // Ensure max length for numeric input
      }
    }
  };

  const validate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const passwordRegex =
       /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*?&.]{8,30}$/;

    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }

    if (!verifyStatus) {
      if (!formData.otp) {
        newErrors.otp = "OTP is required";
      }
    } else {
      if (!formData.password) {
        newErrors.password = "Password is required";
      } else if (!passwordRegex.test(formData.password)) {
        newErrors.password =
          "Password must be 8-30 characters long, include uppercase, lowercase, number, and special character";
      }

      if (!formData.confirmPassword) {
        newErrors.confirmPassword = "Confirm Password is required";
      } else if (formData.password !== formData.confirmPassword) {
        newErrors.confirmPassword = "Passwords do not match";
      }
    }

    return newErrors;
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    // console.log("Submit button clicked");

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      // console.log("Validation errors:", validationErrors);
      return;
    }

    try {
      console.log("Sending OTP verification request with data:", {
        ...formData,
        emailOtp: Number(formData.otp),
      });
      const response = await authService.verifyOtp({
        ...formData,
        emailOtp: Number(formData.otp),
      });

      console.log("OTP verification response:", response);
      if (response.status) {
        setVerifyStatus(true);
        setOtpSent(false);
        setTimer(0);
        showSuccessToast("OTP verified successfully!");
        // navigate("/login");
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          otp: response?.Message || "OTP verification failed",
        }));
        showErrorToast(response?.Message || "OTP verification failed");
      }
    } catch (error) {
      console.error("Error during OTP verification:", error);
      setErrors((prevErrors) => ({
        ...prevErrors,
        otp: "An error occurred during OTP verification. Please try again.",
      }));
      showErrorToast(
        "An error occurred during OTP verification. Please try again."
      );
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      const firstErrorField = Object.keys(validationErrors)[0];
      const firstErrorElement = document.getElementsByName(firstErrorField)[0];
      if (firstErrorElement) {
        firstErrorElement.focus();
      }
      return;
    }
    const resetPasswordData = {
      email: formData.email,
      newPassword: formData.password,
      confirmPassword: formData.confirmPassword,
    };

    try {
      const response = await authService.resetPassword(resetPasswordData);
      if (response.status) {
        showSuccessToast("Password Changed Successfully");
        // setTimeout(() => {
        navigate("/login");
        // }, 3000);
      } else {
        showSuccessToast("Please try again later");
        setErrors({ ...errors, email: response.Message });
      }
    } catch (error) {
      console.error("Error during password reset:", error);
      setErrors({
        ...errors,
        email: "An error occurred during password reset. Please try again.",
      });
    }
  };

  const passwordHide = (data) => {
    if (data == "hide") {
      setPasshide(true);
      setinputType("text");
    } else {
      setPasshide(false);
      setinputType("password");
    }
  };

  const passwordHideconf = (data) => {
    if (data == "hide") {
      setPasshideconf(true);
      setinputTypeconf("text");
    } else {
      setPasshideconf(false);
      setinputTypeconf("password");
    }
  };

  return (
    <div>
      <div className="row register_main container-fluid">
        <div className="col-lg-6">
          <div className="d-flex flex-column mb-5">
            <div className="register_head_logo">
              <Link to="/">
                <img
                  src={require("../assests/Logo.webp")}
                  alt="Logo"
                  className="register_logo cursor-pointer"
                />
              </Link>
            </div>
            <div className="register_left_main mt-3">
              <div className="hero_center">
                {verifyStatus == false ? (
                  <div className="register_form">
                    <span className="register_head_sign">
                      {t("ForgetPassword")}
                    </span>
                    <div className="register_inner_main">
                      <div className="getting_card_content w-100">
                        <div className="register_inner_submain w-100">
                          <div className="reg_inner_small">
                            <span className="register_spans">
                              {t("RegisteredEmail")}
                            </span>
                            <div className="reg_inner_small">
                              <div className="pos_rel">
                                <input
                                  type="text"
                                  name="email"
                                  placeholder={t("EnterTheEmailAddress")}
                                  className="reg_input_forgot_change"
                                  value={formData.email}
                                  onChange={handleInputChange}
                                  onKeyDown={(e) => handleKeyDown(e, "email")}
                                  disabled={otpSent}
                                />
                                {otpLoad == true && !otpSent ? (
                                  <span
                                    className="forgot_send_changedspan"
                                    style={{
                                      cursor: otpSent
                                        ? "not-allowed"
                                        : "pointer",
                                      display: otpSent ? "none" : "",
                                    }}
                                  >
                                    {t("Loading")}
                                  </span>
                                ) : (
                                  <span
                                    className="forgot_send_changedspan"
                                    // onClick={emailValid && !otpSent ? sendOtp : undefined}
                                    onClick={() => sendOtp("Send OTP")}
                                    // onClick={() => emailValid && !otpSent ? sendOtp("Send OTP") : undefined}
                                    style={{
                                      cursor: otpSent
                                        ? "not-allowed"
                                        : "pointer",
                                      display: otpSent ? "none" : "",
                                    }}
                                  >
                                    {t("SendOTP")}
                                    {/* {otpLoad == true && !otpSent ? "Loading .." : "Send OTP"} */}
                                  </span>
                                )}
                              </div>

                              {triedToEnterOtp && !otpEditable && (
                                <span className="error">{t("First")}</span>
                              )}
                              {errors.email && (
                                <span className="error">{errors.email}</span>
                              )}
                            </div>
                            {/* <button onClick={sendOtp} disabled={otpSent}>
                              Send OTP
                            </button> */}
                          </div>
                          {emailSubmitted == true && (
                            <div className="reg_inner_small">
                              <span className="register_spans">{t("OTP")}</span>
                              <div className="reg_pos_rel">
                                <input
                                  type="Number"
                                  name="otp"
                                  placeholder={t("EnterTheOTP")}
                                  className="reg_input"
                                  maxLength={6}
                                  value={formData.otp}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (value.length <= 6) {
                                      handleInputChange(e); // Call your handler if the length is within limits
                                    }
                                  }}
                                  onKeyDown={(e) => handleKeyDown(e, "Number")}
                                />
                                {timer > 0 ? (
                                  <span
                                    className="pos_abs_resend"
                                    style={{ cursor: "not-allowed" }}
                                  >
                                    {t("Resend")} ({timer}s)
                                  </span>
                                ) : (
                                  <>
                                    {otpLoad == false ? (
                                      <span
                                        className="pos_abs_resend"
                                        // onClick={sendOtp}
                                        onClick={() => sendOtp("Resend")}
                                        style={{
                                          cursor:
                                            !emailValid || otpSent
                                              ? "pointer"
                                              : "not-allowed",
                                        }}
                                      >
                                        {t("Resend")}
                                      </span>
                                    ) : (
                                      <span
                                        className="pos_abs_resend"
                                        // onClick={sendOtp}
                                        style={{ cursor: "not-allowed" }}
                                      >
                                        {t("Loading")}
                                      </span>
                                    )}
                                  </>
                                )}
                              </div>
                              {errors.otp && (
                                <span className="error">{errors.otp}</span>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                      {emailSubmitted == true && (
                        <div className="getting_card_content">
                          <div className="reg_btn" onClick={handleOtpSubmit}>
                            <span className="hero_invest"> {t("Submit")} </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="register_form">
                    <span className="register_head_sign">
                      {t("ResetPassword")}
                    </span>
                    <div className="register_inner_main">
                      <div className="getting_card_content w-100">
                        <div className="register_inner_submain w-100">
                          <div className="reg_inner_small">
                            <span className="register_spans">
                              {t("Password")}
                            </span>
                            <div className="reg_pos_rel">
                              <input
                                type={inputType}
                                name="password"
                                placeholder={t("EnterThePassword")}
                                className="reg_input"
                                value={formData.password}
                                onChange={handleInputChange}
                                onKeyDown={(e) => handleKeyDown(e, "password")}
                              />
                              {passHide == true ? (
                                <i
                                  class="fa-regular fa-eye reg_eye"
                                  onClick={() => passwordHide("show")}
                                ></i>
                              ) : (
                                <i
                                  class="fa-regular fa-eye-slash reg_eye"
                                  onClick={() => passwordHide("hide")}
                                ></i>
                              )}
                              {/* <i className="fa-regular fa-eye-slash reg_eye"></i> */}
                              {errors.password && (
                                <span className="error">{errors.password}</span>
                              )}
                            </div>
                          </div>
                          <div className="reg_inner_small">
                            <span className="register_spans">
                              {t("ConfirmPassword")}
                            </span>
                            <div className="reg_pos_rel">
                              <input
                                type={inputTypeconf}
                                name="confirmPassword"
                                placeholder={t("ReEnterThePassword")}
                                className="reg_input"
                                value={formData.confirmPassword}
                                onChange={handleInputChange}
                                onKeyDown={(e) =>
                                  handleKeyDown(e, "confirmPassword")
                                }
                              />
                              {passHidconf == true ? (
                                <i
                                  class="fa-regular fa-eye reg_eye"
                                  onClick={() => passwordHideconf("show")}
                                ></i>
                              ) : (
                                <i
                                  class="fa-regular fa-eye-slash reg_eye"
                                  onClick={() => passwordHideconf("hide")}
                                ></i>
                              )}
                              {/* <i className="fa-regular fa-eye-slash reg_eye"></i> */}
                              {errors.confirmPassword && (
                                <span className="error">
                                  {errors.confirmPassword}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="getting_card_content">
                        <div className="reg_btn" onClick={handleSubmit}>
                          <span className="hero_invest">
                            {" "}
                            {t("ResetPassword")}{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <span className="reg_bottom_span">
                  <Link to="/login">
                    {" "}
                    <span className="reg_check_span">
                      {t("BackToLogin")}
                    </span>{" "}
                  </Link>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 forgot_right_main">
          <div className="login_right">
            <div className="footer_links_div">
              <span className="register_head">{t("ResetYourPassword")}</span>
              <span className="register_subhead">
                {" "}
                {t("Forgot")}
                <br /> {t("trading")}{" "}
              </span>
            </div>
          </div>
        </div>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="email-popup-modal-title"
          aria-describedby="email-popup-modal-description"
        >
          <Box>
            <div className="email-popup-card">
              <div className="email-pop-icon">
                <i class="fa-regular fa-circle-xmark" onClick={handleClose}></i>
              </div>
              <div className="email-pop-img mb-3">
                <img
                  src={require("../assests/binargemail.png")}
                  alt="email-icon"
                />
              </div>
              <h3>{t("Verification")}</h3>
              <p>{t("PleaseVerifyYourEmail")}</p>
              <div className="Submit">
                {verifyLoader == false ? (
                  <div className="reg_btn" onClick={verify_email}>
                    <span className="hero_invest"> {t("VerifyNow")} </span>
                  </div>
                ) : (
                  <div className="reg_btn">
                    <span className="hero_invest"> {t("Loading")} </span>
                  </div>
                )}
              </div>
            </div>
          </Box>
        </Modal>

        <Modal
          open={otpsectionopen}
          onClose={handleCloseOtp}
          aria-labelledby="email-popup-modal-title"
          aria-describedby="email-popup-modal-description"
        >
          <Box>
            <Box>
              <div className="email-popup-card">
                <div className="email-pop-icon">
                  <i
                    class="fa-regular fa-circle-xmark"
                    onClick={handleCloseOtp}
                  ></i>
                </div>
                <div className="email-pop-img mb-3">
                  <img
                    src={require("../assests/binargemail.png")}
                    alt="email-icon"
                  />
                </div>
                <h3>{t("EmailVerify")}</h3>
                <div className="register_inner_submain w-100">
                  <div className="reg_inner_small">
                    <span className="register_spans">{t("EmailCode")}</span>
                    <div className="reg_pos_rel">
                      <input
                        type="number"
                        name="emailOtp"
                        placeholder={t("EnterTheVerificationCode")}
                        className="reg_input email_padding_resp"
                        value={verificationCode}
                        onChange={handleInputChangeNew}
                        onKeyDown={handleKeyDownNew}
                      />
                      {otpSent2 ? (
                        <span className="pos_abs_resend">
                          {t("Resend")} ({timer}s)
                        </span>
                      ) : (
                        <span
                          className="pos_abs_resend"
                          onClick={sendOtpresend}
                          style={{ cursor: "pointer" }}
                        >
                          {t("Resend")}
                        </span>
                      )}
                    </div>

                    {error && <span className="error">{error}</span>}
                  </div>
                </div>
                <div
                  className="getting_card_content"
                  style={{ marginTop: "20px" }}
                >
                  {signloader === true ? (
                    <div className="reg_btn">
                      <span className="hero_invest"> {t("Loading")} </span>
                    </div>
                  ) : (
                    <div className="reg_btn" onClick={handleSubmitNew}>
                      <span className="hero_invest"> {t("Verify")} </span>
                    </div>
                  )}
                </div>
              </div>
            </Box>
          </Box>
        </Modal>
      </div>
    </div>
  );
}

export default Forgot;
